(function () {
  'use strict';

  angular
    .module('crewSignInReport')
    .config(config);

  function config($stateProvider) {
    $stateProvider
      .state('crewSignInReport', {
        url: '/crew-sign-in-report',
        views : {
        	'crewSignInReportView' : {
        		templateUrl: 'crew-sign-in-report/views/crew-sign-in-report.tpl.html',
                controller: 'CrewSignInReportCtrl',
                controllerAs: 'crewSignInReport'
        	}
        }
      });
  }
}());
